import { useRef } from 'react';
import { PageHeader } from '@/components/page-header';
import { useEntranceMotion } from '@/shared/hooks/use-entrance-motion';
import type { WorkspaceData } from '@/shared/types/workspace';
import { Banner } from '@/shared/ui/banner';
import { ClaudeCodeCard } from './claude-code-card';
import { CodexCard } from './codex-card';

type ConnectionsViewProps = { workspace: WorkspaceData };

export function ConnectionsView({ workspace }: ConnectionsViewProps) {
  const rootRef = useRef<HTMLDivElement>(null);
  useEntranceMotion(rootRef, 'connections', { stagger: 0.07 });
  const { claudeCode, codex } = workspace.connections;
  const isNoneConnected =
    (claudeCode.status === 'NOT_CONNECTED' || claudeCode.status === 'WAITING') &&
    (codex.status === 'NOT_CONNECTED' || codex.status === 'WAITING');

  return (
    <div ref={rootRef} className="contents">
      <PageHeader
        title="Connections"
        description="Sessions start in Claude Code or Codex. Connect the one your team uses, or both."
      />
      {isNoneConnected ? (
        <div data-enter="">
          <Banner tone="info" title="No agent is connected.">
            Sessions cannot reach Macswarm until you connect Claude Code or Codex.
          </Banner>
        </div>
      ) : null}
      <ClaudeCodeCard connection={claudeCode} />
      <CodexCard connection={codex} />
    </div>
  );
}
